import { render, staticRenderFns } from "./UpDownCustomerDistribution.vue?vue&type=template&id=83ba02ec&scoped=true"
import script from "./UpDownCustomerDistribution.vue?vue&type=script&lang=js"
export * from "./UpDownCustomerDistribution.vue?vue&type=script&lang=js"
import style0 from "./UpDownCustomerDistribution.vue?vue&type=style&index=0&id=83ba02ec&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83ba02ec",
  null
  
)

export default component.exports